import { AuthContext } from "common/contexts/AuthContext";
import { useContext } from "react";

export function useAuth() {
  return useContext(AuthContext);
}
